var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Markdown',{attrs:{"text":_vm.checkpoint.task}}),_vm._v(" "),_c('h1',[_c('a',{attrs:{"href":_vm.checkpoint.resourceUrl}},[_vm._v(_vm._s(_vm.checkpoint.resourceUrl))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-601f7bce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckpointView.vue
// module id = 241
// module chunks = 0